<template>
    <div>        
        <!-- Still Loading state -->
        <v-container v-if="loading">
            {{ $t('psychologistViewClient.loading') }}
        </v-container>

        <!-- Loaded state -->
        <v-container e-else>

            <!-- Client details-->
            <v-row>
                <v-col cols="12" md="4">
                    <v-card>
                        <v-card-title>{{ client?.firstName }} {{ client?.lastName }}</v-card-title>
                        <v-card-text>
                            <v-table>
                                <tr>
                                    <th>{{ $t('psychologistViewClient.email') }}</th>
                                    <td>{{ client?.email }}</td>
                                </tr>
                            </v-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Evaluations-->
            <v-row>
                <v-col cols="12">
                    <div class="text-h5">{{ $t('psychologistViewClient.evaluations') }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-btn @click="onNewEvaluation()">
                        {{ $t('psychologistViewClient.new_evaluation') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card
                        v-for="(evaluation, idx) in evaluations"
                        :key="`${evaluation.evaluation_id}`"
                        class="mb-2"
                    >
                        <v-container>
                            <!-- Desktop layout -->
                            <v-row @click="onRow(evaluation.token)" class="d-none d-sm-flex">
                                <!-- Desktop layout -->
                                 <v-col cols="3" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistViewClient.created_on') }}</div>
                                    <div class="d-flex flex-column">
                                        <div>{{ formatDate(evaluation.createdOn) }}</div>
                                        <div class="text-disabled">{{ formatTime(evaluation.createdOn) }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistViewClient.client') }}</div>
                                    <div>{{ evaluation.client.first_name }}</div>
                                </v-col>
                                <v-col cols="4" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistViewClient.scales') }}</div>
                                    <div>
                                        <v-chip v-for="scale in evaluation.scales"
                                            :key="scale.scale_id"
                                            size="small"
                                            variant="outlined">
                                            {{ scale.name }}
                                        </v-chip>
                                    </div>
                                </v-col>
                                <v-col cols="2" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistViewClient.status') }}</div>
                                    <v-chip
                                        :style="{color: 'black', backgroundColor: statusColor(evaluation.status) }"
                                        :text="evaluation.status"
                                    />
                                </v-col>
                            </v-row>

                            <!-- Mobile layout -->
                            <div @click="onRow(evaluation.token)" class="d-sm-none">
                                <v-row dense>
                                    <v-col cols="8">
                                        <div class="text-caption text-grey">{{ $t('psychologistViewClient.created_on') }}</div>
                                        <div class="d-flex flex-column">
                                            <div>{{ formatDate(evaluation.createdOn) }}</div>
                                            <div class="text-disabled">{{ formatTime(evaluation.createdOn) }}</div>
                                        </div>
                                    </v-col>
                                    <v-col cols="4">
                                        <div class="text-caption text-grey">{{ $t('psychologistViewClient.client') }}</div>
                                        <div>{{ evaluation.client.first_name }}</div>
                                    </v-col>
                                </v-row>
                                <v-row dense class="mt-2">
                                    <v-col class="d-flex align-center" cols="8">
                                        <div class="text-caption text-grey">{{ $t('psychologistViewClient.scales') }}</div>
                                        <div class="ml-1">
                                            <v-chip v-for="scale in evaluation.scales"
                                                :key="scale.scale_id"
                                                size="small"
                                                variant="outlined">
                                                {{ scale.name }}
                                            </v-chip>
                                        </div>
                                    </v-col>
                                    <v-col cols="4" class="text-right">
                                        <div class="text-caption text-grey text-left">{{ $t('psychologistViewClient.status') }}</div>
                                        <v-chip
                                            :style="{color: 'black', backgroundColor: statusColor(evaluation.status) }"
                                            :text="evaluation.status"
                                            size="small"
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import apiService from '@/services/ApiService'
import {formatDate, formatTime} from '@/utils/time.js'


export default {
    name: "PsychologistViewClientView",
    data() {
        return {
            client: null,
            evaluations: [],
            loading: true,
            clientId: '',
        };
    },

    async created() {
        console.log('PsychologistViewClientView > created');

        this.clientId = this.$route.params.clientId
        console.log(`PsychologistViewClientView > created > clientId = ${this.clientId}`);
        // console.log('NODE_ENV:', process.env.NODE_ENV);
        // console.log('All process.env:', process.env);
        // console.log('VUE_APP_API_ENDPOINT:', process.env.VUE_APP_API_ENDPOINT);

        // const apiUrl = 'http://localhost:7070/api'; // Adjust the API endpoint as needed
        // You can perform any asynchronous operations here if needed
        // await this.loadClient();
        
        // this.loadEvaluations()
        this.loading = false;
    },

    async mounted() {
        this.loading = true;

        this.loadClient();
        this.loadEvaluations();

        this.loading = false;
    },


    methods: {
        formatDate,
        formatTime,

        statusColor: (status) => {
            if(status === 'fresh'){
                return "yellow"
            }
            else if(status === 'started'){
                return "orange"
            }
            else if(status === 'completed'){
                return "green"
            }
            else{
                return "grey"
            }
        },

        async loadClient(){
            console.log(`PsychologistViewClientView > loadClient.`);
            try {
                let client = await apiService.getUser(this.clientId)
                console.log('Response:', client);

                this.client = client;
            } catch (error) {
                console.error('PsychologistViewClientView > loadClient > Error fetching data:', error);
            }
        },

        async loadEvaluations(){
            try {
                this.loading = true
                let evaluations = await apiService.getEvaluationsForClient(this.clientId)
                console.log('PsychologistViewClientView > loadEvaluations > Response:', evaluations);

                this.evaluations = evaluations.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },

        onRow(evaluationToken) {
            // console.log(`PsychologistEvaluations > onRow > evaluationId = ${evaluationId}`);
            console.log(`PsychologistViewClientView > onRow > evaluationToken = ${evaluationToken}`);
            // Navigate with parameters
            this.$router.push({ 
                path: `/psychologist/viewEvaluation/${evaluationToken}`, 
            })
        },

        onNewEvaluation(){
            //TODO: Go to /newEvaluation but with clientId parameter
            this.$router.push({ 
                path: `/psychologist/newEvaluation`, 
                query: {clientId: this.clientId}
            })
        }
    }
}
</script>